import React from 'react';
import DocumentPage, {
  Section,
  Paragraph,
  HazardTable,
} from './DocumentPage';

const DriverThirdPartySitesDoc = ({ onReturnHome }) => (
  <DocumentPage
    pageTitle="Driver Attending Third Party Sites – Risk Assessment"
    documentHeading="Risk Assessment 11: Goods Vehicle Drivers Attending Third Party Sites"
    meta={[
      ['Document Reference', 'PVS-RA-11'],
      ['Version', '1.0'],
      ['Date of Issue', '17th March 2026'],
      ['Next Review Date', '17th March 2028'],
      ['Area / Location', 'Third party sites'],
      ['Activity', 'Goods vehicle drivers attending third party sites e.g. to make deliveries or collections'],
      ['Review Period', '24 months'],
    ]}
    acknowledgment={{
      documentName: 'Driver Attending Third Party Sites – Risk Assessment',
      documentReference: 'PVS-RA-11',
      processActivity: 'Driver Attending Third Party Sites',
      versionNumber: '1.0',
      dateOfIssue: '17th March 2026',
    }}
    onReturnHome={onReturnHome}
  >
    <Section number="1" title="Scope">
      <Paragraph>
        This assessment applies to employees, volunteers and contractors of Pressure Vessel Services
        Limited when attending third party sites to make deliveries or collections.
      </Paragraph>
    </Section>

    <Section number="2" title="Hazard Identification and Risk Assessment">
      <HazardTable
        columns={['Hazard', 'Control Measures Already in Place', 'Additional Control Measures Required']}
        rows={[
          [
            'Drivers being unaware of risks presented on site / Drivers being unaware of site rules, restrictions, and the procedures to follow.',
            [
              'Once on-site drivers report to the designated site reception / site personnel as appropriate and provide relevant details regarding the load they are collecting / delivering.',
              'The driver and crew (when used) familiarise themselves with the site rules.',
            ],
            'None required.',
          ],
          [
            'Unsuitable access to the site entrance e.g. entrance not wide enough, uneven access area etc.',
            [
              'Where practical any site-specific issues are identified prior to commencing a journey and plans put in place.',
              'If problems are encountered the driver will telephone into the office for further advice.',
            ],
            'None required.',
          ],
          [
            'Collision with pedestrians and other vehicles on site / Driver being struck by passing vehicle.',
            [
              'The driver is instructed not to exceed site speed limits and to keep to authorised areas / routes.',
              'Site rules are communicated to the driver.',
              'Where concerns are noted, drivers report to the office.',
              'Hazard warning lights are switched on to alert other road users when needed.',
              'Drivers check around their vehicles before moving off or reversing.',
              'Vehicles are parked correctly in accordance with site rules.',
            ],
            'None required.',
          ],
          [
            'Driver falling into the road.',
            ['Correct procedures are used for accessing / exiting the vehicle cab and load area.'],
            'None required.',
          ],
        ]}
      />
    </Section>

    <Section number="3" title="Reminder">
      <Paragraph className="font-semibold">
        All staff members are required to carry photographic ID at all times when attending a client
        site. You have a duty not only to protect your own health and safety but also to ensure that
        your actions do not put others around you at risk.
      </Paragraph>
    </Section>
  </DocumentPage>
);

export default DriverThirdPartySitesDoc;
